"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Text_1 = require("../Text/Text");
var Breadcrumbs_styles_1 = __importDefault(require("./Breadcrumbs.styles"));
function Breadcrumbs(_a) {
    var className = _a.className, themeOverride = _a.themeOverride, children = _a.children, _b = _a.separator, separator = _b === void 0 ? '/' : _b, others = __rest(_a, ["className", "themeOverride", "children", "separator"]);
    var classes = Breadcrumbs_styles_1.default({ theme: theme_1.useMantineTheme(themeOverride) });
    var items = react_1.default.Children.toArray(children).reduce(function (acc, child, index, array) {
        acc.push(react_1.default.cloneElement(child, {
            className: classes.breadcrumb,
            key: index,
            'data-mantine-breadcrumb': true,
        }));
        if (index !== array.length - 1) {
            acc.push(react_1.default.createElement(Text_1.Text, { size: "sm", "data-mantine-separator": true, className: classes.separator, key: "separator-" + index, themeOverride: themeOverride }, separator));
        }
        return acc;
    }, []);
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.breadcrumbs, className) }, others), items));
}
exports.Breadcrumbs = Breadcrumbs;
Breadcrumbs.displayName = '@mantine/core/Breadcrumbs';
